import { logger } from '../../../../utils/logger';
import { cxoneSdkState } from '../../state';

export function installGetUserMediaInterceptor(): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const originalGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);

  navigator.mediaDevices.getUserMedia = async function (constraints) {
    logger.debug('[CXone DEBUG] getUserMedia called with constraints:', constraints);
    const startTime = Date.now();

    const isAudioOnly =
      constraints &&
      (constraints.audio === true || typeof constraints.audio === 'object') &&
      !constraints.video;

    if (isAudioOnly && cxoneSdkState.preWarmedMediaStream) {
      const audioTracks = cxoneSdkState.preWarmedMediaStream.getAudioTracks();
      const hasActiveTrack = audioTracks.some((track) => track.readyState === 'live');

      if (hasActiveTrack) {
        const clonedStream = cxoneSdkState.preWarmedMediaStream.clone();
        logger.debug(
          `[CXone DEBUG] Returning CLONED pre-warmed stream in ${Date.now() - startTime}ms (instant!)`
        );
        return clonedStream;
      }

      logger.warn(
        '[CXone DEBUG] Pre-warmed stream has no active tracks, falling back to native getUserMedia'
      );
    }

    try {
      const stream = await originalGetUserMedia(constraints);
      logger.debug(`[CXone DEBUG] getUserMedia succeeded in ${Date.now() - startTime}ms (native)`);
      return stream;
    } catch (error) {
      logger.error(`[CXone DEBUG] getUserMedia FAILED after ${Date.now() - startTime}ms:`, error);
      throw error;
    }
  };

  logger.debug('[CXone SDK] getUserMedia interceptor installed (with pre-warm support)');
}
